import { Grid, Paper } from "@mui/material";
import React from "react";
import MainMenu from "../../components/MainMenu";
import CourseList from "../../components/CoursesManagementComponent/CoursesList";

const index = () => {
  return (
    <MainMenu>
      <Grid container>
        <Grid item xs={12}>
          <Paper elevation={3}>
            <CourseList />
          </Paper>
        </Grid>
      </Grid>
    </MainMenu>
  );
};

export default index;
